import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { NeedsWorkApprovalAssignment } from 'src/app/shared/models/needs-work-approval-assignment.model';
import { NeedsApprovalAlertService } from 'src/app/shared/services/needs-approval-alert.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatIconModule } from '@angular/material/icon';

@UntilDestroy()
@Component({
    selector: 'nova-needs-approval-alert',
    standalone: true,
    imports: [CommonModule, MatIconModule, NgClass],
    templateUrl: './needs-approval-alert.component.html',
    styleUrls: ['./needs-approval-alert.component.scss']
})
export class NeedsApprovalAlertComponent implements OnChanges {
    @Input()
    candidateId: number;

    @Input()
    panelClass = '';

    assignments: NeedsWorkApprovalAssignment[];
    needsWorkApprovalCount = 0;
    pinnedNwaAssignment: NeedsWorkApprovalAssignment = null;

    constructor(private readonly needsApprovalAlertService: NeedsApprovalAlertService) {}

    ngOnChanges(): void {
        this.needsApprovalAlertService
            .getNeedsWorkApprovalAssignments(this.candidateId)
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (results) => {
                    this.assignments = results;
                    this.setWorkApprovalStatus();
                }
            });
    }

    setWorkApprovalStatus(): void {
        this.assignments.forEach((assignment) => {
            assignment.needsWorkApproval = NeedsApprovalAlertService.needsWorkApproval(assignment);

            if (assignment.needsWorkApproval) {
                this.needsWorkApprovalCount++;
                this.pinnedNwaAssignment = assignment;
            }
        });
    }
}
